<form class="form" name="formCac" novalidate *ngIf="loaded">
	<pannel [title]="'Le transfert'">
        <div class="form-group col-sm-12">
        	<div class="col-sm-1">
        		<label class="control-label">Antenne&nbsp;:</label>
        	</div>
        	<div class="col-sm-11">
				<label class="checkbox-inline" *ngIf="isCce">
	         		<input type="checkbox"
	         			name="choixDisplayAntenne_toutes" id="choixDisplayAntenne_toutes" 
	         			[ngModel]="toutesAntennes" 
	         			(ngModelChange)="onChangeToutesAntennes($event)"
	         		/>
	         		Toutes
				</label>
                <label *ngFor="let antenne of antennes"
                	class="checkbox-inline"
                	[style]="'color: ' + antenne.couleur"
					>
                    <input type="checkbox"
                           [name]="'choixDisplayAntenne_' + antenne.id" [id]="'choixDisplayAntenne_' + antenne.id"
                           [disabled]="!isCce"
                           [ngModel]="antennesSelected[antenne.id]"
                           (ngModelChange)="onCheckAntenne(antenne.id, $event)"
                    />
                    {{antenne.nom}}
				</label>
            </div>
        </div>
		<div class="form-group col-sm-12" >
			<div class="col-sm-1">
				<label class="control-label">Destinataire&nbsp;:</label>
			</div>
			<div class="col-sm-5">
				<filterable-select
					[id]="'choixDest'"
					[inputClass]="'form-control'"
					[disabled]="!candidats || candidats.length === 0"
					[keyGetter]="candidatKeyGetter"
					[labelGetter]="candidatLabelGetter"
					[list]="candidats"
					[selectedItem]="destinataire"
					(selectedItemChange)="onDestinataireChange($event)"
					>
				</filterable-select>
			</div>
		</div>
	</pannel>
	<pannel [title]="'P&eacute;rim&egrave;tre du transfert'" [expandable]="true">
		<div class="form-group col-sm-12">
			<label class="col-sm-2 control-label">Type de transfert :</label>
			<div class="col-sm-10">
				<label class="radio-inline">
					<input type="radio"
						[value]="true"
						[ngModel]="transfertComplet$ | async"
						(ngModelChange)="transfertComplet$.next(true)"
						/>
					Complet
				</label>
				<label class="radio-inline">
					<input type="radio"
						[value]="false"
						[ngModel]="transfertComplet$ | async"
						(ngModelChange)="transfertComplet$.next(false)"
					/>
					Partiel
				</label>
			</div>
		</div>
		<div class="form-group col-sm-12" *ngIf="!(transfertComplet$ | async)">
        	<div class="col-md-1">
        		<label class="control-label">Technologie&nbsp;:</label>
        	</div>
			<div class="col-md-3">
				<checkbox-list 
					[id]="'choixTechnologie'"
					[wildcardOptionLabel]="'Tous'"
					[itemList]="technologies"
					[labelGetter]="technologieLabelGetter"
					[preselectionFunction]="technologiePreselector"
					[resetCommands]="technologieResetCommand"
					(selectedItemsChange) = "onTechnologieChange($event)"
					>
				</checkbox-list>
			</div>
			<label class="col-md-1 control-label">Maintenance&nbsp;:</label>
			<div class="col-md-3">
				<checkbox-list 
					[id]="'choixMaintenance'"
					[wildcardOptionLabel]="'Tous'"
					[itemList]="maintenances"
					[labelGetter]="maintenanceLabelGetter"
					[preselectionFunction]="maintenancePreselector"
					[resetCommands]="maintenanceResetCommand"
					(selectedItemsChange) = "onMaintenanceChange($event)"
					>
				</checkbox-list>
			</div>
			
			<label class="col-md-1 control-label" *ngIf="afficherFiltreHyperviseur">Hyperviseur&nbsp;:</label>  
			<div class="col-md-3" *ngIf="afficherFiltreHyperviseur">  
				<checkbox-list
					[id]="'choixHyperviseur'"
					[wildcardOptionLabel]="'Tous'"
					[itemList]="hyperviseurs"
					[labelGetter]="hyperviseurLabelGetter"
					[preselectionFunction]="hyperviseurPreselector"
					[resetCommands]="hyperviseurResetCommand"
					(selectedItemsChange)="onHyperviseurChange($event)"
					>
				</checkbox-list>
			</div> 
		</div>
		<div class="form-group col-sm-12 formCacPerimetre" *ngIf="!(transfertComplet$ | async)">
			<ng-container *ngFor="let antenne of perimetre">
				<div *ngIf="antennesSelected[antenne.entity.id]" class="perimetreAntenne">
					<i class="fa fa-sitemap icone"></i>
					<span class="nomAntenne">{{ antenne.entity.nom }}</span>
					<div *ngIf="antenne.parcs as parcs">
						<span>
							<input type="checkbox"
								name="{{'perimAntenne_' + antenne.entity.id}}" id="{{'perimAntenne_' + antenne.entity.id}}"
								[ngModel]="perimetreAntenneComplet[antenne.entity.id]"
								(ngModelChange)="onChangePerimetreAntenneComplet(antenne, $event)"
							/>
							<label for="{{'perimAntenne_' + antenne.entity.id }}">
								&nbsp;Antenne&nbsp;: <b>{{ antenne.entity.nom }}</b>
							</label>
						</span>
						<div class="parcs" *ngFor="let parc of parcs">
							<span class="parc">
								<input type="checkbox"
									name="{{ 'perimParc_' + parc.entity.id }}" id="{{ 'perimParc_' + parc.entity.id }}" 
									[ngModel]="perimetreParcComplet[parc.entity.id]" 
									(ngModelChange)="onChangePerimetreParcComplet(parc, antenne, $event)"
								/>
								<label for="{{ 'perimParc_' + parc.entity.id }}">
									&nbsp;<b>{{ parc.entity.code }} ({{ parc.entity.description }} - <font color="red">{{ parc.entity.energie }}</font> - <font color="green">{{ parc.entity.type }}</font>)</b>&nbsp;:
								</label>
							</span>
							<div class="sousParc" *ngFor="let sousParc of parc.sousParcs">
								<label>-&nbsp;</label>
								<input type="checkbox"
									name="perimSousParc_{{ sousParc.entity.id }}" id="perimSousParc_{{ sousParc.entity.id }}" 
									[ngModel]="perimetreSousParcComplet[sousParc.entity.id]"
									(ngModelChange)="onChangePerimetreSousParcComplet(sousParc, parc, antenne, $event)"
								/>
								<label for="perimSousParc_{{ sousParc.entity.id }}">
									<b>&nbsp;{{ sousParc.entity.code }}</b>&nbsp;:&nbsp;
								</label>
								<span class="ouvrage" *ngFor="let ouvrage of sousParc.ouvrages; let index = index">
									<span *ngIf="index > 0">, </span>
									<input type="checkbox"
										name="{{ 'perimOuvrage_' + ouvrage.id }}" id="{{ 'perimOuvrage_' + ouvrage.id }}" 
										[ngModel]="perimetreOuvrageSelected[ouvrage.id]" 
										(ngModelChange)="onChangePerimetreOuvrage(ouvrage, sousParc, parc, antenne, $event)"
									 />
									<label for="{{ 'perimOuvrage_' + ouvrage.id }}">
										&nbsp;{{ ouvrage.nom }}
									</label>
								</span>
							</div>
							<span class="ouvrage ouvrageSurAntenne" *ngFor="let ouvrage of parc.ouvrages; let index = index">
								<span *ngIf="index > 0">, </span>
								<input type="checkbox"
									name="{{ 'perimOuvrage_' + ouvrage.id }}" id="{{ 'perimOuvrage_' + ouvrage.id }}" 
									[ngModel]="perimetreOuvrageSelected[ouvrage.id]"
									(ngModelChange)="onChangePerimetreOuvrage(ouvrage, null, parc, antenne, $event)"
								/>
								<label for="{{ 'perimOuvrage_' + ouvrage.id }}">
									&nbsp;{{ ouvrage.nom }}
								</label>
							</span>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</pannel>
	<pannel [title]="'Votre p&eacute;rim&egrave;tre actuel'" [folded]="true" [expandable]="true">
		<div class="form-group col-sm-12">
			<ng-container *ngFor="let antenne of perimetre">
				<div *ngIf="antennesSelected[antenne.entity.id]" class="perimetreAntenne">
					<i class="fa fa-sitemap icone"></i>
					<span class="nomAntenne">{{ antenne.entity.nom }}</span>
					<div class="parcs" *ngFor="let parc of antenne.parcs">
						<span class="parc">
							&nbsp;<b>{{ parc.entity.code }} ({{ parc.entity.description }})</b>&nbsp;:
							<ng-container *ngFor="let ouvrage of parc.ouvrages; let index = index">
								{{ index > 0 ? ", " : "" }}{{ ouvrage.nom }}
							</ng-container>
						</span>
						<div class="sousParc" *ngFor="let sousParc of parc.sousParcs">
							<span>-&nbsp;<b>&nbsp;{{ sousParc.entity.code }}</b>&nbsp;:&nbsp;</span>
							<span class="ouvrage" *ngFor="let ouvrage of sousParc.ouvrages; let index = index">
								{{ index > 0 ? ", " : "" }}{{ ouvrage.nom }}
							</span>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</pannel>
		
	<div class="form-group text-center">
		<button class="btn btn-success"
			[disabled]="validationButtonDisabled$ | async"
			(click)="send()"
			>
			Envoyer
		</button>
	</div>
</form>